/*
  <RenderRichContent content={content}/>
*/

import React from "react";
import PortableText from "./PortableText";
import Image from "../primitives/Image";
import ConfirmedSpeaker from "../layout/ConfirmedSpeaker";
import PriceComparison from "../layout/PriceComparison";
import SpeakerCard from "../layout/SpeakerCard";

// Primitives
import EmojiIcon from "../primitives/EmojiIcon";
import Grid from "../primitives/Grid";
import Button from "../primitives/Button";
import WrapRotation from "../primitives/WrapRotation";

function getRandomInt(max) {
  return Math.floor(Math.random() * max);
}

const RenderRichContent = ({ content }) => {
  // If no content dont continue
  if (!content) return null;
  // Checks if the content is an array or not. If its an object, make the content an array
  if (!content.length) {
    content = [content]; // Oh my God this is not good, fix this to something else
  }

  return content.map(c => {
    if (c._type === "plainText") {
      return (
        <React.Fragment key={`${c._type}_${c._key}`}>
          {c.textContent}
        </React.Fragment>
      );
    }

    if (c._type === "imageObject") {
      return (
        <React.Fragment key={`${c._type}_${c._key}`}>
          <WrapRotation>
            <Image image={c.image} alt={c.alt} aspectRatio={c.aspectRatio} />
          </WrapRotation>
        </React.Fragment>
      );
    }

    if (c._type === "speakerSection") {
      return (
        <React.Fragment key={`${c._type}_${c._key}`}>
          <ConfirmedSpeaker speakerData={c} />
        </React.Fragment>
      );
    }

    if (c._type === "highlightedSpeakers") {
      return (
        <React.Fragment key={`${c._type}_${c._key}`}>
          <div className="mb-16">
            <h2
              className="
                mb-8
                uppercase text-center text-xl
              "
            >
              {c.speakerHeader}{" "}
              <EmojiIcon name="leadership" animated className="ml-1" />
            </h2>

            <Grid>
              {c.speakers.map((speaker, i) => {
                let positionOnTop = getRandomInt(2) === 1;

                return (
                  <div
                    className="col-span-12 md:col-span-6 lg:col-span-4"
                    key={speaker + i}
                  >
                    <SpeakerCard
                      key={`speaker_${i}`}
                      title={speaker.name}
                      url={"/speaker/" + speaker.slug.current}
                      language={speaker.language}
                      imageUrl={speaker.image?.asset?.url}
                      position={speaker.stilling}
                      company={speaker.company}
                      positionImageOnTop={positionOnTop}
                    />
                  </div>
                );
              })}
            </Grid>
          </div>
        </React.Fragment>
      );
    }

    if (c._type === "highlightedWorkshops") {
      return (
        <React.Fragment key={`${c._type}_${c._key}`}>
          <div className="mb-16">
            <h2
              className="
                mb-8
                uppercase text-center text-xl
              "
            >
              {c.workshopHeader}{" "}
              <EmojiIcon name="workshop" animated className="ml-1" />
            </h2>

            <Grid>
              {c.workshops.map((workshop, i) => {
                let positionOnTop = getRandomInt(2) === 1;

                return (
                  <div
                    className="col-span-12 md:col-span-6 lg:col-span-4"
                    key={workshop + i}
                  >
                    <SpeakerCard
                      key={`speaker_${i}`}
                      title={workshop.title}
                      url={"/workshop/" + workshop.slug.current}
                      name={workshop.foredragsholdere[0]?.name}
                      // position={workshop.foredragsholdere[0]?.stilling}
                      company={workshop.foredragsholdere[0]?.company}
                      language={workshop.foredragsholdere[0]?.language}
                      imageUrl={workshop.foredragsholdere[0]?.image?.asset?.url}
                      positionImageOnTop={positionOnTop}
                      wordBreak
                    />
                  </div>
                );
              })}
            </Grid>
          </div>
        </React.Fragment>
      );
    }

    if (c._type === "link") {
      return (
        <React.Fragment key={`${c._type}_${c._key}`}>
          <Button
            className="mb-16"
            color="green"
            size="lg"
            href={c.internalPage ? c.internalPage.slug.current : c.url}
            arrows
          >
            {c.text}
          </Button>
        </React.Fragment>
      );
    }

    if (c._type === "richText" || c._type === "simpleRichText") {
      return (
        <React.Fragment key={`${c._type}_${c._key}`}>
          <PortableText blocks={c.textContent} />
        </React.Fragment>
      );
    }

    if (c._type === "priceComparison") {
      return (
        <React.Fragment key={`${c._type}_${c._key}`}>
          <PriceComparison cardList={c.cardList} />
        </React.Fragment>
      );
    }
    return null;
  });
};
export default RenderRichContent;
